type key = "datetime" | "date";

export const formatDatetimeJA = (dateStr: string | undefined) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return (
    date.getFullYear() +
    "年" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "月" +
    date.getDate().toString().padStart(2, "0") +
    "日 " +
    date.getHours().toString().padStart(2, "0") +
    ":" +
    date.getMinutes().toString().padStart(2, "0") +
    ":" +
    date.getSeconds().toString().padStart(2, "0")
  );
};

export const formatYearMonthJA = (dateStr?: string) => {
  if (!dateStr) return "";

  if (/^\d{6}$/.test(dateStr)) { // yyyymm
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    return Number(month) >= 1 && Number(month) <= 12 ? `${year}年${month}月` : "";
  }

  if (/^\d{4}-\d{2}$/.test(dateStr)) { // yyyy-mm
    const [year, month] = dateStr.split("-");
    return Number(month) >= 1 && Number(month) <= 12 ? `${year}年${month}月` : "";
  }

  if (/^\d{4}\/\d{2}$/.test(dateStr)) { // yyyy/mm
    const [year, month] = dateStr.split("/");
    return Number(month) >= 1 && Number(month) <= 12 ? `${year}年${month}月` : "";
  }

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";

  return date.getFullYear() + "年" + (date.getMonth() + 1).toString().padStart(2, "0") + "月";
};


export const getShortDate = (dateStr?: string): Date => {
  const date = new Date(dateStr || "");
  return new Date(
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    date.getDate().toString().padStart(2, "0")
  );
};

export const getShortDatetime = (dateStr?: string): string => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return (
    date.getFullYear() +
    "/" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    date.getDate().toString().padStart(2, "0") +
    " " +
    date.getHours().toString().padStart(2, "0") +
    ":" +
    date.getMinutes().toString().padStart(2, "0")
  );
};

export const getJSTCurrentTime = (type: key) => {
  let time = new Date();
  time.setHours(time.getHours() + 9);
  return type === "datetime"
    ? time.toISOString().slice(0, 16)
    : type === "date"
      ? time.toISOString().slice(0, 10) : "";
};

export const getJSTTime = (time: Date, type: key) => {
  time = new Date(time.getTime()); // not to braak argument
  time.setHours(time.getHours() + 9);
  return type === "datetime"
    ? time.toISOString().slice(0, 16)
    : type === "date"
      ? time.toISOString().slice(0, 10) : "";
};

export const getDateStrFromISOStr = (datetime: string) => {
  return datetime.slice(0, 10);
};

export const getEndOfDateJST = (date: string) => {
  return date + "T23:59:59.000+09:00";
};

export const formatDateStr = (dateStr?: string) =>
  dateStr ? dateStr.replace(/-/g, "/") : "";

// "yyyy-MM-dd" をローカルタイムのDateに変換する（Date("yyyy-MM-dd")はUTC解釈になり日付がずれるため使わない）
export const getLocalDateFromDateStr = (dateStr: string): Date => {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

// DateをローカルタイムのDate文字列（"yyyy-MM-dd"）に変換する
export const getDateStrFromDate = (date: Date): string =>
  `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}`;

// Dateを日本語の日付表記（例: "2027年1月3日"）に変換する
export const formatDateJA = (date: Date): string =>
  `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;

// "yyyyMM" 形式の年月を、指定ヶ月数だけ前後にずらす
export const addMonths = (yyyyMM: string, delta: number): string => {
  const year = Number(yyyyMM.slice(0, 4));
  const month = Number(yyyyMM.slice(4, 6));
  const date = new Date(Date.UTC(year, month - 1 + delta, 1));
  return `${date.getUTCFullYear()}${String(date.getUTCMonth() + 1).padStart(
    2,
    "0"
  )}`;
};

// "yyyyMM" 形式の年月を年・月に分解する
export const splitYearMonth = (
  yyyyMM: string
): { year: number; month: number } => ({
  year: Number(yyyyMM.slice(0, 4)),
  month: Number(yyyyMM.slice(4, 6)),
});
